import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';

@Component({
	selector: 'app-verify-store',
	templateUrl: './user-verification.component.html',
	styleUrls: ['./user-verification.component.scss']
})
export class UserVerificationComponent implements OnInit, OnDestroy {
	public error?: string;
	public isError: boolean = false;
	public isSuccess: boolean = false;
	public isExpired: boolean = false;
	public successMessage: string;
	public originUrl = '';
	public user: Partial<User> = {
		_id: null,
		username: null,
		email: null,
		firstName: null,
		lastName: null,
		phoneNumber: null,
		roles: [],
		password: null,
		oldPassword: null,
		uniqueString: null,
		imageUrl: null,
		city: null
	};
	private subscriptions: Subscription[] = [];

	constructor(
		private userService: UserService,
		private authService: AuthService,
		private activatedRoute: ActivatedRoute,
		public router: Router
	) {}

	async ngOnInit() {
		this.originUrl = window.location.origin;
		const res = this.getRouteParams();
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	private getRouteParams = () => {
		this.isError = false;
		this.isSuccess = false;
		const routeSub = combineLatest([this.activatedRoute.params, this.activatedRoute.queryParams]).subscribe(
			async res => {
				this.user._id = res[1]?.userId;
				const data = {
					userId: res[1]?.userId,
					hashedUniqueString: res[1]?.hashedUniqueString
				};

				this.userService.emailVerification(data).subscribe(
					res => {
						if (res?.done) {
							this.isSuccess = true;
							this.successMessage = res.message;
						} else {
							this.isError = true;
							this.error = res.message;
							this.isExpired = res.expired;
						}
					},
					err => {
						this.isError = true;
						this.error = err;
						if (err == 'Link has expired, Press the button below to resend a new verification link')
							this.isExpired = true;
					}
				);
			}
		);
		this.subscriptions.push(routeSub);
	};
	Expired = async () => {
		if (this.isExpired) {
			this.userService
				.findById(this.user._id, false, false, false, null, null, 'verify', null, 'findById')
				.subscribe(res => {
					this.user = res;
					this.userService.resentEmailVerification(this.user).subscribe(
						res => {
							if (res?.done) {
								this.isSuccess = true;
								this.successMessage = res.message;
							} else {
								this.isError = true;
								this.error = res.message;
								this.isExpired = res.expired;
							}
						},
						err => {
							this.isError = true;
							this.error = err.error.message;
							this.isExpired = err.error.expired;
						}
					);
				});
			this.router.navigate(['/auth/login']);
		}
	};
	logout() {
		this.authService.logout();
	}
}
